module.exports = function getResource(label, vars = []) {
    const resources = {
        zeroResults: 'Sorry, we couldn’t find a match for',
        spellCheck: 'Please check your search terms and try again.'
    };
    return resources[label];
};
